import {createGlobalStyle} from 'styled-components';

export const DataVizColorStyles = createGlobalStyle`
  :root {
    --color-dataviz-blue100: rgba(147, 197, 253, 1);
    --color-dataviz-blue200: rgba(59, 130, 246, 1);
    --color-dataviz-blue300: rgba(30, 64, 175, 1);
    --color-dataviz-blurple100: rgba(149, 142, 235, 1);
    --color-dataviz-blurple200: rgba(79, 67, 221, 1);
    --color-dataviz-blurple300: rgba(35, 25, 138, 1);
    --color-dataviz-brown100: rgba(245, 216, 172, 1);
    --color-dataviz-brown200: rgba(234, 177, 89, 1);
    --color-dataviz-brown300: rgba(93, 66, 32, 1);
    --color-dataviz-cyan100: rgba(183, 225, 237, 1);
    --color-dataviz-cyan200: rgba(75, 180, 210, 1);
    --color-dataviz-cyan300: rgba(44, 87, 100, 1);
    --color-dataviz-gray100: rgba(209, 213, 220, 1);
    --color-dataviz-gray200: rgba(133, 144, 161, 1);
    --color-dataviz-gray300: rgba(3, 6, 21, 1);
    --color-dataviz-green100: rgba(171, 235, 205, 1);
    --color-dataviz-green200: rgba(46, 204, 129, 1);
    --color-dataviz-green300: rgba(28, 125, 86, 1);
    --color-dataviz-lime100: rgba(185, 246, 203, 1);
    --color-dataviz-lime200: rgba(116, 237, 150, 1);
    --color-dataviz-lime300: rgba(5, 213, 63, 1);
    --color-dataviz-orange100: rgba(251, 146, 60, 1);
    --color-dataviz-orange200: rgba(234, 88, 12, 1);
    --color-dataviz-orange300: rgba(154, 37, 0, 1);
    --color-dataviz-pink100: rgba(249, 168, 212, 1);
    --color-dataviz-pink200: rgba(236, 72, 153, 1);
    --color-dataviz-pink300: rgba(190, 18, 60, 1);
    --color-dataviz-red100: rgba(237, 179, 174, 1);
    --color-dataviz-red200: rgba(219, 104, 93, 1);
    --color-dataviz-red300: rgba(127, 42, 41, 1);
    --color-dataviz-teal100: rgba(153, 246, 228, 1);
    --color-dataviz-teal200: rgba(20, 184, 166, 1);
    --color-dataviz-teal300: rgba(17, 94, 89, 1);
    --color-dataviz-violet100: rgba(216, 180, 254, 1);
    --color-dataviz-violet200: rgba(168, 85, 247, 1);
    --color-dataviz-violet300: rgba(107, 33, 168, 1);
    --color-dataviz-yellow100: rgba(255, 242, 176, 1);
    --color-dataviz-yellow200: rgba(253, 224, 71, 1);
    --color-dataviz-yellow300: rgba(180, 83, 9, 1);
  }
`;
